import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cmWEB,
  cr,
  gs,
  a,
  ls,
  BoxC,
  BtnC,
  GridC,
  RootC,
  TextC,
  useNgnz,
  _cv_31___Mz
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as RootC from "./_ccmRootC";
import * as cmWEB from "./_cmWEB";
import * as _cm from './_cm';
import * as _cmFTH from './_cmFTH';
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useNgnz } from "./_csNgn";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

import * as icvI10___Mz from './icvI10___Mz';
//import * as icvI11___Mz from './icvI11___Mz';
import * as icvI1z___TzAby from './icvI1z___TzAby';
import * as icvI1z___TzUse from './icvI1z___TzUse';
import * as ihdI11 from './ihdI11';

import * as icm from './icm';
import * as icv from './icv';

let $role = 's';
let $ctt = 'r';
let $i10r_fsts = [] as ht.ls;
let $_31rz = {} as ht.dz;
let $date1 = hfDTM.cvtFdm(hfDTM.getTdy());
let $date2 = '';
let $i11rs = [] as ht.ls;

export const N = (pz: {
}) => {

  const _gUserz = gs.useUserz();

  const _sPz = ls.usePz({
    steps: [0],
  });

  const _sNgnz = useNgnz();

  React.useEffect(() => {
    _sNgnz.getPmrzAsync()
    .then(async (_pmrz: ht.dz) => {
      $ctt = _pmrz.c ?? 'r';
      $role = _pmrz.r ?? 's';
      const _dmn = Number(hf.cvtNbr('d', _pmrz.d ?? '', icv.srtz.nbrz4));
      const _31r_icn = Number(hf.cvtNbr('d', _pmrz.i ?? '', icv.srtz.nbrz4));
      const _addMth = Number(_pmrz.a ?? 0);
      _gUserz.set({
        _dmn: _dmn,
      });
      const _31z = await _cv_31___Mz.load_31rDzAsync({
        _31r_icn: _31r_icn,
      })
      $_31rz = _31z._31rz;
      await icm.setStgzAsync({
        _31r_fst: $_31rz._fst,
      });
      const _ls = await icvI10___Mz.loadI10rLsAsync({
        _31r_fst: $_31rz._fst,
        i10rt1100i: 10, // 単体部屋のみ
      });
      $i10r_fsts = _ls.map((_dz: ht.dz) => _dz._fst);
      $date1 = hfDTM.addMth(hfDTM.cvtFdm(hfDTM.getTdy()), _addMth);
      await _sPz.set({
        ctt: $ctt,
        dffz: icm.grtDffz({
          role: 'd',
          mode: $ctt,
        }),
      });
    })
  }, [
  ]);

  const _gStgz = gs.useStgz();
  //hf.l(`icvI1z___Tz 1015: ${hf.s(_gUserz.crt.i19rz)}`)  

  let _bClk = false; // click
/*
  if (
    $ctt == 'r' && 
    $role == 'd' && 
    _sPz.crt.steps[0] == 0 &&
    $date1 < _gStgz.crt.alyMthSttDate
  ) _bClk = true;
*/
  if (
    $ctt == 'r' && 
    _sPz.crt.steps[0] == 0 &&
    $date1 < _gStgz.crt.alyMthSttDate
  ) _bClk = true; // 内部・公開ともにクリックで表示

  return (

    cr.c(RootC.N, {
      key: -10,      
      adbType: 'dtpCmnz',
      bdyCz: {
        boxStlz: 
          cr.d('p') ? 
            a('dw/120 mh/a mt/1')
          : a('dw/f mh/a mt/1'),
        oClds: [

          cr.c(BoxC.N, {
            key: -5,
            boxStlz: a(`dw/f fd/rec mb/1 pr/1`),
            oClds: [
              cr.c(BtnC.N, {
                key: -10,
                boxStlz: a(`br/1 dw/20 fd/ccc sc/lt7 pv/0.25`),
                lblCz: {
                  textz: {
                    pfx: '閉じる',
                    stlz: a('tc/lt1, tb'),
                  },
                },
                pslPtyz: {
                  onPress: () => {
                    cmWEB.cls();
                  }
                }
              })
            ]
          }),

          _bClk ?
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: 'マス目をクリックすると該当日の予約団体が表示されます',
              stlz: a('tb tc/bl7 ts/l'),
            },
            boxStlz: a(`mb/1 p/1`),
          })
          : undefined,

          _sPz.crt.steps[0] == 0 ?
          cr.c(icvI1z___TzAby.V3, {
            key: -37,
            sPz: _sPz,
            boxStlz: a('mb/2'),
            cz: {
              bEdit: false,
              bNext: true,
              i10r_fsts: $i10r_fsts,
              date: $date1,
              _31r_fst: $_31rz._fst,
              row: cr.d('p') ? 1 : 2,
              pfx: 
                $ctt == `r` ?
                  `現在の空き状況　${$_31rz._pfx ?? ''}`
                : $ctt == `e` ?
                  `現在のエントリー状況　${$_31rz._pfx ?? ''}`
                : '',
              sttMth: 
                $role == 'd' && $ctt == `r` ?
                  String(hfDTM.getTdy()).substring(0,7)
                : undefined,
              endMth:
                $role == 'd' && $ctt == `r` ?
                  String(hfDTM.addMth(hfDTM.getTdy(), 2)).substring(0,7)
                : undefined,
              role: $role,
              onPrs: 
                _bClk ?
                async (_dz: ht.dz) => { // マス目をクリックした場合に使用状況画面を表示
                  $date2 = _dz.date;

//                  $i11rs = await icvI11___Mz.loadI11rLsAsync({
//                    _31r_fst: $_31rz._fst,
//                    i1zrd3100s: $date2,
//                    i10rt1100i: 10,
//                    i1zrs1100iMnm: 70,
//                    lwrType: 1,
//                  });

                  $i11rs = await _cmFTH.loadLsAsync(ihdI11.grtQryLoadI11rLsAsync(_cm.grtUz(), {
                    _31r_fst: $_31rz._fst,
                    i1zrd3100s: $date2,
                    i10rt1100i: 10,
                    i1zrs1100iMnm: 70,
                    lwrType: 1,
                  }));

                  //hf.l(`icvI1zD20Rz 200: ${hf.s($i11rs)}`);
                  _sPz.set({
                    steps: [1],
                  })
                }
                : undefined,
            }
          })
          : undefined,

          _sPz.crt.steps[0] == 1 ?
          cr.c(GridC.N, {
            key: -20,
            abtType: 'nolineCmnz',
            boxStlz: a(`f/1`),
            lineCs: [
              {
                boxStlz: a('f/n mb/2'),
                cellCs: [
                  {
                    oClds:[

                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'leftIconz',
                        bfrIconCz: {
                          iconPtyz: a('icn/chevron-left ics/2'),
                        },
                        lblCz: {
                          textz: {
                            pfx: '戻る',
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            $i11rs = [];
                            _sPz.set({
                              steps: [0],
                            })
                          }
                        }
                      }),

                    ],
                  },
                  {
                    boxStlz: a(`f/2`),
                    oClds:[

                      cr.c(TextC.N, {
                        key: -10,
                        textz: {
                          pfx:
                            $ctt == `r` ?
                              `現在の空き状況　` + ($_31rz._pfx ?? '') + ' ' + hfDTM.f($date2, '年月日（曜）', false)
                            : $ctt == `e` ?
                              `現在のエントリー状況　` + ($_31rz._pfx ?? '') + ' ' + hfDTM.f($date2, '年月日（曜）', false)
                            : '',
                          stlz: a('tb'),
                        },
                      })

                    ],
                  },
                  {
                    oClds:[
                    ],
                  }
                ]
              },
              {
                boxStlz: a('f/n'),
                cellCs: [
                  {
                    oClds:[
                      cr.c(icvI1z___TzUse.N, {
                        key: -20,
                        i11rs: $i11rs,
                        bDtl: false,
                      })
                    ],
                  }
                ]
              }
            ]
          })
          : undefined,

        ]
      }
    })

  );
};
